import axios from "axios";
import axiosInstance from "../axiosConfig";

// Service for handling financial report related API calls
const reportService = {
  // Get profit and loss report
  getProfitLoss: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/profit-loss", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching profit and loss report:", error);
      throw error;
    }
  },

  // Get balance sheet report
  getBalanceSheet: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/balance-sheet", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching balance sheet report:", error);
      throw error;
    }
  },

  // Get cashflow report
  getCashflow: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/cashflow", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching cashflow report:", error);
      throw error;
    }
  },

  // Get customer aging report
  getCustomerAging: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/customer-aging", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching customer aging report:", error);
      throw error;
    }
  },

  // Get vendor aging report
  getVendorAging: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/aged-creditors", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching vendor aging report:", error);
      throw error;
    }
  },

  // Get tax report
  getTaxReport: async (params) => {
    try {
      const response = await axiosInstance.get("/reports/tax", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching tax report:", error);
      throw error;
    }
  },

  // No /reports/dashboard-summary endpoint exists on the backend; fail clearly.
  getDashboardSummary: async () => {
    const message = "Dashboard summary is not available from the server";
    throw { error: message, message };
  },
};

export default reportService;
